<template>
  <div>
    <form @submit.prevent="createReservation">
      <div class="flex flex-col md:flex-row">
        <div class="w-full md:w-1/2 md:mx-4 md:mr-16">
          <input
            id="jmeno"
            required
            v-model="formData.name"
            @input="delete errorMessages['name']"
            class="w-full h-12 bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-ch-800"
            type="text"
            placeholder="Jméno a Příjmení"
          />
          <p class="text-red-600" v-if="errorMessages['name']">
            {{ errorMessageFormat(errorMessages["name"]) }}
          </p>

          <input
            id="email"
            required
            v-model="formData.email"
            @input="delete errorMessages['email']"
            class="w-full h-12 mt-4 bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-ch-800"
            type="email"
            placeholder="Email"
          />
          <p class="text-red-600" v-if="errorMessages['email']">
            {{ errorMessageFormat(errorMessages["email"]) }}
          </p>

          <input
            id="mobil"
            required
            v-model="formData.mobile"
            @input="delete errorMessages['mobile']"
            class="w-full h-12 mt-4 bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-ch-800"
            type="text"
            placeholder="Mobilní telefon"
          />
          <p class="text-red-600" v-if="errorMessages['mobile']">
            {{ errorMessageFormat(errorMessages["mobile"]) }}
          </p>

          <input
            id="pocetLidi"
            required
            v-model="formData.pocetLidi"
            @input="delete errorMessages['pocetLidi']"
            class="w-full h-12 mt-4 bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-ch-800"
            type="number"
            placeholder="Počet osob"
          />
          <p class="text-red-600" v-if="errorMessages['pocetLidi']">
            {{ errorMessageFormat(errorMessages["pocetLidi"]) }}
          </p>
        </div>
        <div class="w-full md:w-1/2 md:mx-4">
          <input
            id="from"
            required
            v-model="formData.from"
            @input="delete errorMessages['from']"
            class="w-full h-12 mt-4 md:mt-0 bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-ch-800"
            type="date"
            placeholder="Datum do"
          />
          <p class="text-red-600" v-if="errorMessages['from']">
            {{ errorMessageFormat(errorMessages["from"]) }}
          </p>

          <input
            id="to"
            required
            v-model="formData.to"
            @input="delete errorMessages['to']"
            class="w-full h-12 mt-4 bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-ch-800"
            type="date"
            placeholder="Datum Od"
          />
          <p class="text-red-600" v-if="errorMessages['to']">
            {{ errorMessageFormat(errorMessages["to"]) }}
          </p>

          <textarea
            id="message"
            v-model="formData.message"
            style="height: 112px"
            class="mt-4 w-full bg-gray-200 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-ch-800"
            type="email"
            placeholder="Vaše dotazy"
          >
          </textarea>
        </div>
      </div>

      <div class="flex mt-6">
        <label class="flex items-center ml-4">
          <input
            required
            v-model="formData.checked"
            type="checkbox"
            class="bg-gray-200"
          />
          <span class="ml-2 text-sm text-chsoftblue"
            >Potvrzuji, že jsem se seznámil/a s
            <a @click="$modal.open('#provozni-rad-modal')"
              ><span class="underline cursor-pointer">Provozním řádem</span></a
            >
            Chaty pod Luhačovickou přehradou.</span
          >
        </label>
      </div>

      <div class="flex justify-center pt-4">
        <button
          :disabled="formData.sent || loading"
          class="py-2 px-4 bg-chred hover:bg-chreddark disabled:hover:bg-chred disabled:opacity-90 cursor-pointer text-white rounded text-lg"
          type="submit"
        >

        {{ loading ? 'Zpracováváme objednávku...' : 'Vytvořit objednávku'}}
        </button>
      </div>
    </form>

    <div class="pt-10 flex justify-center" v-if="displaySuccessMessage">
      <button
        @click="displaySuccessMessage = false"
        class="bg-green-600 text-white px-4 py-3 rounded"
      >
        Vaše objednávka byla úspěšně zaznamenána. Více informací jsme Vám
        zaslali na Váši emailovou adresu.
      </button>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  data() {
    return {
      formData: {
        name: "",
        email: "",
        mobile: "",
        pocetLidi: "",
        from: "",
        to: "",
        message: "",
        checked: false,
        sent: false,
      },
      displaySuccessMessage: false,
      errorMessages: [],
      loading: false,
    };
  },

  methods: {
    errorMessageFormat(val) {
      return val.toString().replace(/[""]/gi, "");
    },
    createReservation() {
      this.loading = true;
      axios
        .post("/reservations", this.formData)
        .then((res) => {
          if (res.status === 200) {
            this.clearForm();
            this.showSuccessMessage();
            this.clearErrors();
            this.formData.sent = true;
          }
        })
        .catch((err) => {
          this.clearErrors();
          this.errorMessages = err.response.data.errors;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showSuccessMessage() {
      this.displaySuccessMessage = true;
    },
    clearForm() {
      Object.keys(this.formData).forEach((key) => (this.formData[key] = ""));
    },
    clearErrors() {
      this.errorMessages = [];
    },
  },
};
</script>

<style></style>
